import React from 'react';

import { Props as ButtonProps } from './Button';
import PrimaryButton from './variants/PrimaryButton';
import SecondaryButton from './variants/SecondaryButton';
import TertiaryButton from './variants/TertiaryButton';

export { ButtonSize } from './Button';

export enum ButtonVariant {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Tertiary = 'Tertiary',
}

export type Props = ButtonProps & { variant?: ButtonVariant };

function Button(
  { variant = ButtonVariant.Primary, ...props }: Props,
  ref: ButtonProps['ref'],
) {
  switch (variant) {
    case ButtonVariant.Primary:
      return <PrimaryButton {...props} ref={ref} />;
    case ButtonVariant.Secondary:
      return <SecondaryButton {...props} ref={ref} />;
    case ButtonVariant.Tertiary:
      return <TertiaryButton {...props} ref={ref} />;
    default:
      return <PrimaryButton {...props} ref={ref} />;
  }
}

export default React.forwardRef(Button);
